import { render, staticRenderFns } from "./MallsContractsGrid.vue?vue&type=template&id=e4f9174e&"
import script from "./MallsContractsGrid.vue?vue&type=script&lang=ts&"
export * from "./MallsContractsGrid.vue?vue&type=script&lang=ts&"
import style0 from "./MallsContractsGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports